import { useFeatureAvailable } from 'App/components/hooks';
import { Feature } from 'Store/actions/FeatureHelperActions';

const useProjectBoardAllowed = () => {
	return useFeatureAvailable(Feature.PROJECT_PLAN);
};

export default useProjectBoardAllowed;
